import AllFollowers from "./AllFollowers";
import Annotations from "./Annotations";
import AverageVisit from "./AverageVisit";
import Followed from "./Followed";
import Highlights from "./Highlights";
import Engagement from "./Engagement";
import NewFollowers from "./NewFollowers";
import ReturnVisits from "./ReturnVisits";
import SiteStatistics from "./SiteStatistics";
import TopProjects from "./TopProjects";
import TopSearches from "./TopSearches";
import Visitors from "./Visitors";
import ShareClicks from "./ShareClicks";
import Citations from "./Citations";
import TextSectionViews from "./TextSectionViews";

export default {
  Annotations,
  AllFollowers,
  AverageVisit,
  Followed,
  Highlights,
  Engagement,
  NewFollowers,
  ReturnVisits,
  SiteStatistics,
  TopProjects,
  TopSearches,
  Visitors,
  ShareClicks,
  Citations,
  TextSectionViews
};
